/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImagePlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABdElEQVR4nN2VO0sDQRDHg6gELCzEb6CN2FofCAEhmUeEvRkhcthcL2ojSNqIrV8ifgC19rC0s9fGIAhWWkjwwcYLiblcLne5NA78YWF25rc7s49C4d+YMWYeWU6BpIWs31kELE/I2rC5IgDryJoYo2pEACG9txqSFpB8hkq1K5tr2A76JuiD4zizAGbFyvf9OSR5TAMZCUCSZsRP0swHQHrpeF5x0O94XhFJrqYKAJbrKZZIL3LrgW2ybWx5e2fVKv8mdyTP3WNqx2nvwhiAGJHeAYuPrGfI2gbSD0TdZ95d2jJmGUhO7KIyAuS+VKotdGOAtWZhg7kqJIfjAr6Q5S0cvyOatUhgD3aLJEGcf1gPXspVd71er88AyTmiuxcb3Bc/LqANVd3s+ixkVPLUACA9SEo4EaBSdTcKCQa25oknrq8ng891zCl6NcYsdhZEEiTNB9ab1B8OkByPqkDCl6mNpJ3A780+Sg2Y1KYPIAn+1Dy0HydiTr7ASWbPAAAAAElFTkSuQmCC)
 */
export const ImagePlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8.67c0 .12-.34.17-.39.06A2.87 2.87 0 0 0 19 12a3 3 0 0 0-2.7 1.7c-.1.18-.36.22-.48.06l-.47-.63a2 2 0 0 0-3.2 0L9.93 16.1l-.5-.64a1.5 1.5 0 0 0-2.35 0l-1.86 2.32A.75.75 0 0 0 5.81 19h5.69c.28 0 .5.23.54.5.17.95.81 1.68 1.69 2.11.11.06.06.39-.06.39H5a3 3 0 0 1-3-3V5Zm8.2.98c.23-.91-.88-1.55-1.55-.9a.93.93 0 0 1-1.3 0c-.67-.65-1.78-.01-1.55.9a.93.93 0 0 1-.65 1.12c-.9.26-.9 1.54 0 1.8.48.14.77.63.65 1.12-.23.91.88 1.55 1.55.9a.93.93 0 0 1 1.3 0c.67.65 1.78.01 1.55-.9a.93.93 0 0 1 .65-1.12c.9-.26.9-1.54 0-1.8a.93.93 0 0 1-.65-1.12Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
